module.exports = __webpack_public_path__ + "img/musulmanes.0ad0715c.jpg";